import axios from 'axios';
import userService from './user-service';
import history from '../history';
import { save as saveException } from './exception-service';
import { ERROR_TYPE_APPLICATION } from '../constants';

const host = `${window.location.protocol}//${window.location.host}/`;
const profileName = process.env.REACT_APP_IRPM_PROFILE_NAME || process.env.NODE_ENV;
const safeGate = `${process.env.REACT_APP_IRPM_SAFE_GATE}/${host}#/jwt/\${jti}/\${nounce}`
  .replace('{profile_name}', profileName);
const renewJwtEndPoint = `${process.env.REACT_APP_IRPM_API_URL}/renew-jwt/`;

const fetchUser = (pathname, search, resolve) => {
  const urlParams = pathname.split('/');
  if (urlParams.length >= 4) {
    const jti = urlParams[2];
    const nounce = urlParams[3];
    userService
      .fetchCurrentUser(jti, nounce)
      .then(() => {
        const [, redirectUrl] = search.match(/\?redirect_url=(.*)/);
        resolve(redirectUrl || '/');
      });
  } else {
    resolve('/404');
  }
};

const authenticate = async (force = false) => {
  if (userService.isLoggedIn() && !force) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const { pathname, search } = history.location;
    if (pathname.startsWith('/jwt')) {
      fetchUser(pathname, search, resolve);
    } else {
      window.location.href = `${safeGate}?redirect_url=${pathname}`;
    }
  });
};

const renew = async () => {
  if (userService.isLoggedIn()) {
    const currentUser = userService.getCurrentUser();
    const { access_token: sjwt } = currentUser || {};
    const res = await axios.get(renewJwtEndPoint + JSON.stringify({ sjwt }));
    const result = res.data;
    if (result.d) {
      const { jwt } = result.d;
      userService.extractJwtToken(jwt);
      return true;
    }
    saveException('error', [{
      title: 'Renew failed',
      message: 'Renew session failed. Please login!',
    }], ERROR_TYPE_APPLICATION);
    console.error(result.x);
  }
  return false;
};

export {
  safeGate,
  authenticate,
  fetchUser,
  renew,
};
